<template>
  <b-modal id="upload_file_modal" ref="upload_file_modal" hide-footer no-close-on-esc no-close-on-backdrop>
    <div slot="modal-header" class="mh">
      <div id="mh-text">
        <!-- Different modal header depending on type file being uploaded for -->
        <h1>
          <i class="fas fa-file-upload"></i>
          <span v-if="$store.state.files.type === 'company'">Upload Client File(s)</span>
          <span v-else-if="$store.state.files.type === 'contact'">Upload Contact File(s)</span>
          <span v-else-if="$store.state.files.type === 'order_job'">Upload Order Job File(s)</span>
          <span v-else-if="$store.state.files.type === 'worker'">Upload Worker File(s)</span>
        </h1>
        <p id="mh-info">Upload File(s) for {{ $store.state.files.name }}</p>
      </div>
      <button v-if="!saving" id="mh-close" class="btn-close" @click="hideModal()"><i class="fas fa-times"></i></button>
    </div>

    <ValidationObserver ref="uploadFileForm" slim>
      <form role="form" @submit.prevent="upload_file()">
        <div class="row">
          <div class="col-12 text-center">
            <h4 class="mb-0">SYSTEM WILL AUTO COMPRESS FILE</h4>
            <p class="mb-3">Except for multi-page PDF files<br>There is a limit of 40MB total for multiple file upload.</p>
          </div>
          <div class="col-12">
            <hr class="mt-1 mb-3">
          </div>
        </div>

        <!-- Company File inputs -->
        <div v-if="$store.state.files.type === 'company'">
          <div class="row" v-for="(f,i) in files">
            <div class="col-8">
              <h5>File {{ i + 1 }}</h5>
            </div>
            <div class="col-4 text-right">
              <button v-if="files.length > 1" class="orcaBtn sm_btn danger sm_btn" @click.prevent="remove_file(i)"><i class="fas fa-trash"></i> &nbsp; Remove File</button>
            </div>
            <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'File Type ' + (i + 1)" tag="div" class="form-group col-11 offset-1">
              <label class="form-label" :for="'file_type_' + (i + 1)">File Type</label>
              <multiselect v-model="f.file_type" :id="'file_type_' + (i + 1)" :name="'file_type_' + (i + 1)" placeholder="" :allow-empty="false" :selectLabel="''"
                           :options="file_types" label="file_type" :show-labels="false" @input="file_type_select(f.file_type, f)"></multiselect>
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </ValidationProvider>
            <div class="offset-1 form-group col-11" v-if="f.file_type !== null" >
              <file_input @file-chosen="file_select($event, f)" :required="true" :accepted_file_type="'image/*,.pdf,.heic'" :selected_file="f.file"
                          @checking-file="checking_file($event)" @checking-file-name="checking_file_name($event)"
                          :hidden_id="'file_' + (i + 1)" :file_error_name="'File ' + (i + 1)"></file_input>
            </div>
          </div>

        </div>
        <!-- Contact File inputs -->
        <div v-else-if="$store.state.files.type === 'contact'"></div>
        <!-- Order job File inputs -->
        <div v-else-if="$store.state.files.type === 'order_job'">
          
          <div class="row" v-for="(f,i) in files">
            <div class="col-8">
              <h5>File {{ i + 1 }}</h5>
            </div>
            <div class="col-4 text-right">
              <button v-if="files.length > 1" class="orcaBtn sm_btn danger sm_btn" @click.prevent="remove_file(i)"><i class="fas fa-trash"></i> &nbsp; Remove File</button>
            </div>
            <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'File Type ' + (i + 1)" tag="div" class="form-group col-11 offset-1">
              <label class="form-label" :for="'file_type_' + (i + 1)">File Type</label>
              <multiselect v-model="f.file_type" :id="'file_type_' + (i + 1)" :name="'file_type_' + (i + 1)" placeholder="" :allow-empty="false" :selectLabel="''"
                           :options="file_types" label="file_type" :show-labels="false" @input="file_type_select(f.file_type, f)"></multiselect>
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </ValidationProvider>
            <div class="offset-1 form-group col-11" v-if="f.file_type !== null" >
              <file_input @file-chosen="file_select($event, f)" :required="true" :accepted_file_type="'image/*,.pdf,.heic'" :selected_file="f.file"
                          @checking-file="checking_file($event)" @checking-file-name="checking_file_name($event)"
                          :hidden_id="'file_' + (i + 1)" :file_error_name="'File ' + (i + 1)"></file_input>
            </div>
          </div>

        </div>
        <!-- Worker File inputs -->
        <div v-else-if="$store.state.files.type === 'worker'">
          <div class="row" v-for="(f,i) in files">
            <div class="col-8">
              <h5>File {{ i + 1 }}</h5>
            </div>
            <div class="col-4 text-right">
              <button v-if="files.length > 1" class="orcaBtn sm_btn danger sm_btn" @click.prevent="remove_file(i)"><i class="fas fa-trash"></i> &nbsp; Remove File</button>
            </div>
            <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'File Type ' + (i + 1)" tag="div" class="form-group col-11 offset-1">
              <label class="form-label" :for="'file_type_' + (i + 1)">File Type</label>
              <multiselect v-model="f.file_type" :id="'file_type_' + (i + 1)" :name="'file_type_' + (i + 1)" placeholder="" :allow-empty="false" :selectLabel="''"
                           :options="file_types" label="file_type" :show-labels="false" @input="file_type_select(f.file_type, f)"></multiselect>
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </ValidationProvider>
            <div class="offset-1 form-group" v-if="f.file_type !== null"
                 :class="[f.file_type !== null && (f.file_type.id === 10 || f.file_type.id === 11 || f.file_type.id === 19 || f.file_type.id === 20 || f.file_type.id
                                 === 25 || f.file_type.id === 26 || f.file_type.id === 27 || f.file_type.id === 29 || f.file_type.id === 30 || f.file_type.id === 31
                                 || f.file_type.id === 55) ?
                                 'col-6' : 'col-11']">
              <file_input @file-chosen="file_select($event, f)" :required="true" :accepted_file_type="'image/*,.pdf,.heic'" :selected_file="f.file"
                          @checking-file="checking_file($event)" @checking-file-name="checking_file_name($event)"
                          :hidden_id="'file_' + (i + 1)" :file_error_name="'File ' + (i + 1)"></file_input>
            </div>
            <!-- if pe insurance cert OR pi insurance cert OR if pe & pi insurance cert OR if passport OR if drivers licence OR if biometric ID OR CSCS Card -->
            <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'Document Expiry Date ' + (i + 1)" tag="div" class="col-5 form-group"
                                v-if="f.file_type !== null && (f.file_type.id === 10 || f.file_type.id === 11 || f.file_type.id === 19 || f.file_type.id === 20 || f.file_type.id
                                 === 25 || f.file_type.id === 26 || f.file_type.id === 27 || f.file_type.id === 29 || f.file_type.id === 30 || f.file_type.id === 31 
                                 || f.file_type.id === 55)">
              <label class="form-label" :for="'document_expiry_date_' + (i + 1)">Document Expiry Date</label>
              <datepicker v-model="f.document_expiry_date" :id="'document_expiry_date_' + (i + 1)" :name="'document_expiry_date_' + (i + 1)" :input-class="['date-input',
              'requiredField', classes]" :format="dateFormat" :clear-button="true" clear-button-icon="far fa-calendar-times"
                          @input="select_document_expiry(f.document_expiry_date, f)" :use-utc="true"></datepicker>
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </ValidationProvider>
            <!-- if settlement status doc -->
            <div class="col-6 offset-1" v-if="f.file_type !== null && (f.file_type.id === 23)">
              <div class="row">
                <label class="col-7 cardLabel" style="line-height: 19px" :for="'settlement_indefinite_' + (i + 1)">Indefinite Settlement?</label>
                <div class="col-5 form-group">
                  <bootstrap-toggle v-model="f.settlement_indefinite" :id="'settlement_indefinite_' + (i + 1)" :name="'settlement_indefinite_' + (i + 1)" :options="{ on: 'Yes',
                  off: 'No' }"/>
                </div>
              </div>
            </div>
            <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'Settlement Expiry Date ' + (i + 1)" tag="div" class="col-5 form-group"
                                v-if="f.file_type !== null && f.file_type.id === 23 && !f.settlement_indefinite">
              <label class="form-label" :for="'settlement_expiry_' + (i + 1)">Settlement Expiry Date</label>
              <datepicker v-model="f.settlement_expiry" :id="'settlement_expiry_' + (i + 1)" :name="'settlement_expiry_' + (i + 1)" :input-class="['date-input',
              'requiredField', classes]" :format="dateFormat" :clear-button="true" clear-button-icon="far fa-calendar-times"
                          @input="select_settlement_expiry(f.settlement_expiry, f)" :use-utc="true"></datepicker>
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </ValidationProvider>
            <!-- if visa doc -->
            <div class="col-6 offset-1" v-if="f.file_type !== null && (f.file_type.id === 24)">
              <div class="row">
                <label class="col-7 cardLabel" style="line-height: 19px" :for="'visa_indefinite_' + (i + 1)">Indefinite Visa?</label>
                <div class="col-5 form-group">
                  <bootstrap-toggle v-model="f.visa_indefinite" :id="'visa_indefinite_' + (i + 1)" :name="'visa_indefinite_' + (i + 1)" :options="{ on: 'Yes', off: 'No' }"/>
                </div>
              </div>
            </div>
            <ValidationProvider rules="required" v-slot="{errors, classes}" :name="'Visa Expiry Date ' + (i + 1)" tag="div" class="col-5 form-group"
                                v-if="f.file_type !== null && f.file_type.id === 24 && !f.visa_indefinite">
              <label class="form-label" :for="'visa_expiry_' + (i + 1)">VISA Expiry Date</label>
              <datepicker v-model="f.visa_expiry" :id="'visa_expiry_' + (i + 1)" :name="'visa_expiry_' + (i + 1)" :input-class="['date-input', 'requiredField', classes]"
                          :format="dateFormat" :clear-button="true" clear-button-icon="far fa-calendar-times" @input="select_visa_expiry(f.visa_expiry, f)" :use-utc="true"></datepicker>
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>
          <div class="row mt-3" v-if="check_add_files && !check_file">
            <div class="col-12">
              <button @click.prevent="add_file" class="orcaBtn greenBtn sm_btn w-100"><i class="fas fa-plus"></i> &nbsp; ADD FILE</button>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <hr>
          </div>
          <div class="col-12" v-if="!check_file">
            <div class="float-right">
              <button type="submit" class="btn orcaBtn sm_btn" :disabled="saving">
                <span v-if="saving" class="btnLoading"><i class="fas fa-spinner fa-pulse"></i>Uploading ...</span>
                <span v-else>UPLOAD and CLOSE</span>
              </button>
            </div>
          </div>
          <div class="col-12 text-center font-weight-bold text-uppercase" v-else-if="check_file">
            <i class="fas fa-spinner fa-pulse"></i> &nbsp; CHECKING {{ check_file_name }} ...
          </div>
        </div>
      </form>
    </ValidationObserver>
  </b-modal>
</template>

<script>
import Multiselect from "vue-multiselect";
import Datepicker from 'vuejs-datepicker';
import BootstrapToggle from 'vue-bootstrap-toggle';
import file_input from 'partials/files/fileInput';

export default {
  name: "upload_file",
  components: {file_input, Multiselect, Datepicker, BootstrapToggle},
  data() {
    return {
      file_types_original: [],
      file_types: [],
      files: [
        {
          file_type: null,
          file: null,
          document_expiry_date: null,
          settlement_indefinite: null,
          settlement_expiry: null,
          visa_indefinite: null,
          visa_expiry: null
        }
      ],
      saving: false,
      check_file: false,
      check_file_name: '',

      uk_ireland: ['United Kingdom (UK)', 'Wales', 'Scotland', 'Northern Ireland', 'England', 'Republic of Ireland'],
      eu: ['Austria', 'Belgium', 'Bulgaria', 'Croatia', 'Cyprus', 'Czech Republic', 'Denmark', 'Estonia', 'Finland', 'France', 'Germany', 'Greece',
        'Hungary', 'Italy', 'Latvia', 'Lithuania', 'Luxembourg', 'Malta', 'The Netherlands', 'Poland', 'Portugal', 'Romania', 'Slovakia', 'Slovenia', 'Spain', 'Sweden']
    }
  },
  computed: {
    /**
     * check if can add another file for upload or not (file and type not missing from any others)
     */
    check_add_files() {
      if (this.$store.state.files.type === 'worker') {
        let temp_file_types = this.files.filter(f => {
          let test = true;
          if (f.file_type !== null) {
            // if pe insurance cert OR pi insurance cert OR if pe & pi insurance cert OR if passport OR if drivers licence OR if biometric ID type 
            // or if CSCS Card-> reset variables
            if (f.file_type.id === 10 || f.file_type.id === 11 || f.file_type.id === 19 || f.file_type.id === 20 || f.file_type.id === 25 || f.file_type.id === 26
                || f.file_type.id === 27 || f.file_type.id === 29 || f.file_type.id === 30 || f.file_type.id === 31 || f.file_type.id === 55) {
              if (f.document_expiry_date !== null && f.file !== null) {
                test = false;
              }
            }
            // if not settlement status type -> reset variables
            else if (f.file_type.id === 23) {
              if (f.settlement_expiry !== null && f.file !== null) {
                test = false;
              }
            }
            // if not visa status type -> reset variables
            else if (f.file_type.id === 24) {
              if (f.visa_expiry !== null && f.file !== null) {
                test = false;
              }
            }
            else {
              if (f.file !== null) {
                test = false;
              }
            }
          }
          if (test) {
            return f;
          }
        })
        return temp_file_types.length <= 0;
      }
    },
  },
  beforeMount() {
    if (this.$store.state.files.type === 'company') {
      // filter file types for company
      this.file_types_original = this.$store.state.crm_options.file_types.filter(ft => ft.record_type_id === 1)
      this.file_types = this.$store.state.crm_options.file_types.filter(ft => ft.record_type_id === 1)

      // Exclude previously uploaded files
      if (this.$store.state.files.uploaded_files !== null) {
        for (let i = 0; i < this.$store.state.files.uploaded_files.length; i++) {
          // do not remove 'other_1' type from list of types : exclude all else
          if (this.$store.state.files.uploaded_files[i] !== 13) {
            this.file_types_original = this.file_types_original.filter(ft => ft.record_type_id === 1 && ft.id !== this.$store.state.files.uploaded_files[i])
            this.file_types = this.file_types.filter(ft => ft.record_type_id === 1 && ft.id !== this.$store.state.files.uploaded_files[i])
          }
        }
      }
    }
    else if (this.$store.state.files.type === 'order_job') {
      // filter file types for order_job
      this.file_types_original = this.$store.state.crm_options.file_types.filter(ft => ft.record_type_id === 4)
      this.file_types = this.$store.state.crm_options.file_types.filter(ft => ft.record_type_id === 4)

      // Exclude previously uploaded files
      if (this.$store.state.files.uploaded_files !== null) {
        for (let i = 0; i < this.$store.state.files.uploaded_files.length; i++) {
          // do not remove 'other_1' type from list of types : exclude all else
          if (this.$store.state.files.uploaded_files[i] !== 13) {
            this.file_types_original = this.file_types_original.filter(ft => ft.record_type_id === 4 && ft.id !== this.$store.state.files.uploaded_files[i])
            this.file_types = this.file_types.filter(ft => ft.record_type_id === 4 && ft.id !== this.$store.state.files.uploaded_files[i])
          }
        }
      }
    }
    else if (this.$store.state.files.type === 'worker') {
      // filter file types for worker (exclude old id_1 && id_2 && other_2 types)
      this.file_types_original = this.$store.state.crm_options.file_types.filter(ft => ft.record_type_id === 3 && ft.id !== 6 && ft.id !== 7 && ft.id !== 14)
      this.file_types = this.$store.state.crm_options.file_types.filter(ft => ft.record_type_id === 3 && ft.id !== 6 && ft.id !== 7 && ft.id !== 14)
      // UK nationality -> exclude : Biometric ID, settlement status, visa
      if (this.$store.state.files.nationality !== null && this.uk_ireland.includes(this.$store.state.files.nationality.country_name)) {
        this.file_types_original = this.file_types_original.filter(ft => ft.record_type_id === 3 && ft.id !== 19 && ft.id !== 20 && ft.id !== 30 && ft.id !== 23 && ft.id !== 24)
        this.file_types = this.file_types.filter(ft => ft.record_type_id === 3 && ft.id !== 19 && ft.id !== 20 && ft.id !== 30 && ft.id !== 23 && ft.id !== 24)
      }
      // EU nationality -> exclude : Biometric ID
      // if (this.$store.state.files.nationality !== null && this.eu.includes(this.$store.state.files.nationality.country_name)) {
      //   this.file_types_original = this.file_types_original.filter(ft => ft.record_type_id === 3 && ft.id !== 19 && ft.id !== 20 && ft.id !== 30)
      //   this.file_types = this.file_types.filter(ft => ft.record_type_id === 3 && ft.id !== 19 && ft.id !== 20 && ft.id !== 30)
      // }
      // International nationality -> exclude : settlement status
      if (this.$store.state.files.nationality !== null && !this.uk_ireland.includes(this.$store.state.files.nationality.country_name) &&
          !this.eu.includes(this.$store.state.files.nationality.country_name)) {
        this.file_types_original = this.file_types_original.filter(ft => ft.record_type_id === 3 && ft.id !== 19 && ft.id !== 20 && ft.id !== 30)
        this.file_types = this.file_types.filter(ft => ft.record_type_id === 3 && ft.id !== 19 && ft.id !== 20 && ft.id !== 30)

        // this.file_types_original = this.file_types_original.filter(ft => ft.record_type_id === 3 && ft.id !== 23)
        // this.file_types = this.file_types.filter(ft => ft.record_type_id === 3 && ft.id !== 23)
      }
      // if not limited company -> exclude : Professional Indemnity Insurance Certificate & Public Employers Liability Insurance Certificate
      if (this.$store.state.files.employment_type !== null && this.$store.state.files.employment_type.id !== 32) {
        this.file_types_original = this.file_types_original.filter(ft => ft.record_type_id === 3 && ft.id !== 11 && ft.id !== 10 && ft.id !== 31)
        this.file_types = this.file_types.filter(ft => ft.record_type_id === 3 && ft.id !== 11 && ft.id !== 10 && ft.id !== 31)
      }
      // depending on VAT registration remove option : if not -> exclude : VAT Certificate
      if (!this.$store.state.files.vat_registered) {
        this.file_types_original = this.file_types_original.filter(ft => ft.record_type_id === 3 && ft.id !== 12)
        this.file_types = this.file_types.filter(ft => ft.record_type_id === 3 && ft.id !== 12)
      }
      // Exclude previously uploaded files
      if (this.$store.state.files.uploaded_files !== null) {
        for (let i = 0; i < this.$store.state.files.uploaded_files.length; i++) {
          // do not remove 'other_1' type from list of types : exclude all else
          if (this.$store.state.files.uploaded_files[i] !== 13) {
            this.file_types_original = this.file_types_original.filter(ft => ft.record_type_id === 3 && ft.id !== this.$store.state.files.uploaded_files[i])
            this.file_types = this.file_types.filter(ft => ft.record_type_id === 3 && ft.id !== this.$store.state.files.uploaded_files[i])
          }
        }
      }
    }
  },
  methods: {
    /**
     * hide modal
     */
    hideModal() {
      this.$refs.upload_file_modal.hide();
      this.$store.commit('HIDE_FILE_MODAL');
    },
    /**
     * Date Format for datepicker
     * -------------------------------
     */
    dateFormat(date) {
      return this.$moment.utc(date).format("DD/MM/YYYY");
    },
    /**
     * Format date picked
     * -------------------------------
     */
    select_document_expiry(selected_date, file) {
      if (selected_date !== null) {
        file.document_expiry_date = this.$moment.utc(selected_date).format('YYYY-MM-DD');
      }
    },
    select_settlement_expiry(selected_date, file) {
      if (selected_date !== null) {
        file.settlement_expiry = this.$moment.utc(selected_date).format('YYYY-MM-DD');
      }
    },
    select_visa_expiry(selected_date, file) {
      if (selected_date !== null) {
        file.visa_expiry = this.$moment.utc(selected_date).format('YYYY-MM-DD');
      }
    },
    /**
     * filter file types - selected types
     * ?? and existing uploaded types
     */
    filter_file_types() {
      let current_file_types = [];
      this.$nextTick(() => {
        let temp_file_types = {};
        // company files filter (keep 'other' in the list)
        if (this.$store.state.files.type === 'company') {
          temp_file_types = this.files.filter(f => {
            if (f.file_type !== null && f.file_type.id !== 13) {
              return f;
            }
          })
        }
        // order_job files filter (keep 'other' in the list)
        else if (this.$store.state.files.type === 'order_job') {
          temp_file_types = this.files.filter(f => {
            if (f.file_type !== null && f.file_type.id !== 13) {
              return f;
            }
          })
        }
        // worker files filter (keep 'other' in the list)
        else if (this.$store.state.files.type === 'worker') {
          temp_file_types = this.files.filter(f => {
            if (f.file_type !== null && f.file_type.id !== 13) {
              return f;
            }
          })
        }
        current_file_types = temp_file_types.map(ft => ft.file_type.id);
        this.file_types = this.file_types.filter(ft => current_file_types.indexOf(ft.id) === -1)
      })
    },
    /**
     * remove file from files array
     */
    remove_file(index) {
      this.files.splice(index, 1);
      this.file_types = this.file_types_original;
      this.$nextTick(() => this.filter_file_types())
    },
    /**
     * Filter file types as you add files - make sure that duplicate types can't be uploaded (other than other)
     */
    file_type_select(val, file) {
      this.$nextTick(() => {
        if (val !== null) {
          // if not pe insurance cert OR pi insurance cert OR if pe & pi insurance cert OR if passport OR if drivers licence OR if biometric ID type 
          // or not CSCS Card -> reset variables
          if (val.id !== 10 && val.id !== 11 && val.id !== 19 && val.id !== 20 && val.id !== 25 && val.id !== 26 && val.id !== 27 && val.id !== 29 && val.id !== 30 && val.id !==
              31 && val.id !== 55) {
            file.document_expiry_date = null;
          }
          // if not settlement status type -> reset variables
          if (val.id !== 23) {
            file.settlement_indefinite = null;
            file.settlement_expiry = null;
          }
          // if not visa status type -> reset variables
          if (val.id !== 24) {
            file.visa_indefinite = null;
            file.visa_expiry = null;
          }
        }
        this.file_types = this.file_types_original;
        this.$nextTick(() => this.filter_file_types())
      })
    },
    /**
     * update file when selection made
     */
    file_select(file, index_file) {
      index_file.file = file
    },
    /**
     * If file (PDF) being checked -> set value
     */
    checking_file(e) {
      this.check_file = e;
    },
    /**
     * If file (PDF) being checked -> set name to be displayed
     */
    checking_file_name(name) {
      this.check_file_name = name;
    },
    /**
     * add another file to be uploaded
     */
    add_file() {
      this.files.push({
        file_type: null,
        file: null,
        document_expiry_date: null,
        settlement_indefinite: null,
        settlement_expiry: null,
        visa_indefinite: null,
        visa_expiry: null
      })
      this.file_types = this.file_types_original;
      this.$nextTick(() => this.filter_file_types())
    },
    /**
     * UPLOAD FILE FUNCTION
     */
    upload_file() {
      this.$refs.uploadFileForm.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.uploadFileForm);
        }
        else {
          this.saving = true;
          let files = [];
          // check the type the file upload is relevant to (client/contact/order/worker)
          if (this.$store.state.files.type === 'company') {
            // loop over all the files inputted and append as FormData
            for (let i = 0; i < this.files.length; i++) {
              let file = new FormData();
              let file_name = this.files[i].file_type.ident + '-' + this.$moment.utc().format('DDMMYYHHmmss') + '.' + /[^.]*$/.exec(this.files[i].file.name.replace(/ /g, "-"))[0];
              file.append('company_id', this.$store.state.files.id);
              file.append('belongs_to_type', 'App\\Models\\Companies\\Company');
              file.append('belongs_to_id', this.$store.state.files.id);
              file.append('file_master_type_id', this.files[i].file_type.id);
              file.append('file_name', file_name);
              file.append('extension', /[^.]*$/.exec(this.files[i].file.name.replace(/ /g, "-"))[0]);
              file.append('file_path', 'storage/company_files/files/' + this.$store.state.files.id + '/' + file_name);

              file.append('document_expiry_date', this.files[i].document_expiry_date);
              file.append('settlement_indefinite', this.files[i].settlement_indefinite);
              file.append('settlement_expiry', this.files[i].settlement_expiry);
              file.append('visa_indefinite', this.files[i].visa_indefinite);
              file.append('visa_expiry', this.files[i].visa_expiry);

              file.append('uploaded_file', this.files[i].file);
              file.append('log_by_type', 'App\\Models\\Users\\User');
              file.append('log_by_id', this.$store.state.auth.me.id);
              // add to be uploaded file array
              files.push(file);
            }
          }
          else if (this.$store.state.files.type === 'order_job') {
            // loop over all the files inputted and append as FormData
            for (let i = 0; i < this.files.length; i++) {
              let file = new FormData();
              let file_name = this.files[i].file_type.ident + '-' + this.$moment.utc().format('DDMMYYHHmmss') + '.' + /[^.]*$/.exec(this.files[i].file.name.replace(/ /g, "-"))[0];
              file.append('order_job_id', this.$store.state.files.id);
              file.append('belongs_to_type', 'App\\Models\\Orders\\Jobs\\OrderJob');
              file.append('belongs_to_id', this.$store.state.files.id);
              file.append('file_master_type_id', this.files[i].file_type.id);
              file.append('file_name', file_name);
              file.append('extension', /[^.]*$/.exec(this.files[i].file.name.replace(/ /g, "-"))[0]);
              file.append('file_path', 'storage/order_job_files/files/' + this.$store.state.files.id + '/' + file_name);

              file.append('document_expiry_date', this.files[i].document_expiry_date);
              file.append('settlement_indefinite', this.files[i].settlement_indefinite);
              file.append('settlement_expiry', this.files[i].settlement_expiry);
              file.append('visa_indefinite', this.files[i].visa_indefinite);
              file.append('visa_expiry', this.files[i].visa_expiry);

              file.append('uploaded_file', this.files[i].file);
              file.append('log_by_type', 'App\\Models\\Users\\User');
              file.append('log_by_id', this.$store.state.auth.me.id);
              // add to be uploaded file array
              files.push(file);
            }
          }
          else if (this.$store.state.files.type === 'worker') {
            // loop over all the files inputted and append as FormData
            for (let i = 0; i < this.files.length; i++) {
              let file = new FormData();
              let file_name = this.files[i].file_type.ident + '-' + this.$moment.utc().format('DDMMYYHHmmss') + '.' + /[^.]*$/.exec(this.files[i].file.name.replace(/ /g, "-"))[0];
              file.append('worker_id', this.$store.state.files.id);
              file.append('belongs_to_type', 'App\\Models\\Workers\\Worker');
              file.append('belongs_to_id', this.$store.state.files.id);
              file.append('file_master_type_id', this.files[i].file_type.id);
              file.append('file_name', file_name);
              file.append('extension', /[^.]*$/.exec(this.files[i].file.name.replace(/ /g, "-"))[0]);
              file.append('file_path', 'storage/worker_files/files/' + this.$store.state.files.id + '/' + file_name);

              file.append('document_expiry_date', this.files[i].document_expiry_date);
              file.append('settlement_indefinite', this.files[i].settlement_indefinite);
              file.append('settlement_expiry', this.files[i].settlement_expiry);
              file.append('visa_indefinite', this.files[i].visa_indefinite);
              file.append('visa_expiry', this.files[i].visa_expiry);

              file.append('uploaded_file', this.files[i].file);
              file.append('log_by_type', 'App\\Models\\Users\\User');
              file.append('log_by_id', this.$store.state.auth.me.id);
              // add to be uploaded file array
              files.push(file);
            }
          }
          // loop through files to be uploaded array and upload
          let file_promises = [];
          for (let f of files) {
            file_promises.push(new Promise(resolve => {
              axios.post(this.crmApiPath + 'file', f, {headers: {'Content-Type': 'application/json'}}).then(() => {
                resolve();
              })
            }))
          }
          Promise.all(file_promises).then(() => {
            this.$snotify.success('Files Uploaded');
            this.$bus.$emit('file::reload', {type: 'worker', action: true});
            this.$bus.$emit('logs::reload', {type: 'worker', action: true});
            this.$nextTick(() => this.hideModal());
          })
        }
      })
    }
  }
}
</script>
